
IF.init = function() {
	//this.loginBoxAnimation();
};
